import * as Yup from "yup";

export const identityVerificationValidationSchema = Yup.object().shape({});
